import React, { Component } from 'react'
import { Row, Table, Breadcrumb, Button } from 'antd'
import { Link } from 'react-router-dom'
import { api, app } from "../../app"
import utils from "../../utils"

class PRanks extends Component {
    constructor(props) {
        super(props)
        this.state = {
            token: '',
            data_loding: true,  //数据加载
            teamList: [],   //团队列表
        }
    }

    componentDidMount() {
        this._isMounted = true
        this.getTokeni();
        this.dataSource()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 数据源
     */
    dataSource() {
        const _this = this
        app.post(api.TeamInfo).then(({ flag, data, msg }) => {
            if (_this._isMounted) {
                _this.setState({ data_loding: false })
                if (flag === 1) {
                    _this.setState({ teamList: utils.addArrayKey(data) })
                } else {
                    app.alert(msg, "error")
                }
            }
        })
    }

    /**
* 获取token
* @returns {Promise<void>}
*/
    getTokeni = async () => {
        let { flag, data, msg } = await app.post(api.getToken);
        if (flag === 1) {
            this.setState({
                token: data.token
            });
        } else {
            app.alert(msg, 'warn');
        }
    };

    render() {
        const columns = [
            {
                title: '省份',
                dataIndex: 'province',
                key: 'province',
                width: '15%'
            },
            {
                title: '队伍数量',
                dataIndex: 'count',
                key: 'count',
                width: '10%'
            },
            {
                title: '品牌督导官',
                dataIndex: 'schultheiss',
                key: 'schultheiss',
                width: '15%',
                render: (text, record) => {
                    const schultheiss = record.schultheiss
                    if (schultheiss.length > 0) {
                        const schultheis = schultheiss[0]
                        return (
                            <span><Link to={`/player/${schultheis.team_id}/${schultheis.indexno}?token=${this.state.token}`}
                                className="ranks_table_a">{schultheis.vname}</Link></span>
                        )
                    } else {
                        return (
                            <span>暂无</span>
                        )
                    }
                }
            },
            // {
            //     title: '管理员',
            //     dataIndex: 'administrator',
            //     key: 'administrator',
            //     width: '20%',
            //     render: (text, record) => {
            //         if (record.administrator.length > 0) {
            //             return (
            //                 <span>
            //                     {
            //                         record.administrator.map((s, index) => {
            //                             return (
            //                                 <Link key={index + 1} to={`/player/${s.team_id}/${s.indexno}?token=${this.state.token}`}
            //                                     className="ranks_table_a">{s.vname}</Link>)
            //                         })
            //                     }
            //                 </span>)
            //         } else {
            //             return (
            //                 <span>暂无</span>
            //             )
            //         }
            //     }
            // },
            {
                title: '认证人数',
                dataIndex: 'total',
                key: 'total',
                width: '10%'
            },
            {
                title: '年度入队人数',
                dataIndex: 'yearJoinCount',
                key: 'yearJoinCount',
                width: '15%'
            },
            {
                title: '详情',
                width: '15%',
                dataIndex: 'xq',
                key: 'xq',
                render: (text, record) => (
                    <div>
                        <div><Link to={"/ranks/pro/" + record.province} className="ranks_table_a">队伍列表</Link></div>
                        <div style={{ marginTop: 10 }}><Link to={"/ranks/province/" + record.province} className="ranks_table_a">查看详情</Link></div>
                    </div>
                )
            },
        ], teamList = this.state.teamList, loading = this.state.data_loding, locale = {
            filterTitle: '筛选',
            filterConfirm: '确定',
            filterReset: '重置',
            emptyText: loading ? '正在加载中...' : '暂无数据',
        }
        return (
            <div className="ranks_content">
                <Row type="flex" justify="space-between" className="r_page_title">
                    <div>省队列表<span>Team list</span></div>
                    <Button icon="rollback" onClick={() => app.backPage(this)}>返回</Button>
                </Row>
                <Breadcrumb separator=">" className="r_right_breadcrumb">
                    <Breadcrumb.Item><Link to="/">首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>省队列表</Breadcrumb.Item>
                </Breadcrumb>
                <Table className="ranks_table"
                    size="small"
                    locale={locale}
                    columns={columns}
                    dataSource={teamList}
                    loading={loading}
                    pagination={false}
                    scroll={{ y: 'calc(100% - 46px)' }}
                />
            </div>

        )
    }
}

export default PRanks



// WEBPACK FOOTER //
// ./src/routes/ranks/PRanks.jsx